import Vue from 'vue';
import VueSanitize from 'vue-sanitize';
import App from './App.vue';

import './utils/directives';
import './utils/filters';

import { Loading, Message } from 'element-ui';

import locale from 'element-ui/lib/locale';
import lang from 'element-ui/lib/locale/lang/ru-RU';
import Vuetify from 'vuetify';
// import 'vuetify/dist/vuetify.min.css';
import router from './router';
import { store } from './store/index';
// const components = { Loading };
// for (let component of Object.values(components)) {
//   Vue.component(component.name, component);
// }

Vue.use(Vuetify);
const defaults = {
  allowedTags: [
    // Headers
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    // Styles
    'b',
    'i',
    'em',
    'strong',
    's',
    'sup',
    'sub',
    // Paragraph / Line-breaks
    'p',
    'br',
    'hr',
    // Anhor
    'a',
    // Image
    'img',
    'svg',
    'path',
    // List
    'ol',
    'ul',
    'li',
    // Blockquote
    'blockquote',
    // Table
    'table',
    'tbody',
    'caption',
    'tr',
    'th',
    'td',
    // Misc
    'div',
    'span'
  ],
  allowedAttributes: {
    h1: ['id'],
    h2: ['id'],
    h3: ['id'],
    h4: ['id'],
    h5: ['id'],
    h6: ['id'],
    p: ['style'],
    a: ['href', 'target'],
    img: ['src', 'width', 'height', 'style'],
    svg: ['width', 'height', 'viewBox', 'fill', 'xmlns'],
    path: ['d', 'fill', 'fill-rule', 'clip-rule'],
    div: ['id', 'class', 'style'],
    td: ['style']
  },
  allowedClasses: {
    '*': ['*']
  }
};

Vue.use(VueSanitize, defaults);
Vue.use(Loading);
locale.use(lang);
Vue.prototype.$message = Message;
Vue.config.productionTip = false;

const vuetify = new Vuetify({});

if (process.env.NODE_ENV === 'development') {
  new Vue({
    store,
    vuetify,
    router,
    render: h => h(App)
  }).$mount('#app');
} else {
  new Vue({
    store,
    vuetify,
    router,
    render: h => h(App)
  }).$mount('#app');
}
